var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ParkingSpaceNew" },
    [_vm.type == "xg" ? _c("ParkingSpaceNewxg") : _c("ParkingSpaceNewjp")],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }